import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconWarning = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20ZM11 10.9996C11 11.5519 11.4477 11.9996 12 11.9996C12.5523 11.9996 13 11.5519 13 10.9996V8.9996C13 8.44732 12.5523 7.9996 12 7.9996C11.4477 7.9996 11 8.44732 11 8.9996V10.9996ZM11 14.9996C11 15.5519 11.4477 15.9996 12 15.9996C12.5523 15.9996 13 15.5519 13 14.9996C13 14.4473 12.5523 13.9996 12 13.9996C11.4477 13.9996 11 14.4473 11 14.9996Z"
      fill="currentColor"
    />
  </SvgIcon>
)
